import { Routes, Route } from 'react-router-dom'
import Login from './pages/auth/login'
import Signup from './pages/auth/signup'
import Dashboard from './pages/dashboard'
import Projects from './pages/dashboard/projects'
import ProjectDetails from './pages/dashboard/project'

function App() {
  return (
    <Routes>
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/signup" element={<Signup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/projects" element={<Projects />} />
      <Route path="/dashboard/project/:id" element={<ProjectDetails />} />
      <Route path="/" element={<Login />} />
    </Routes>
  )
}

export default App 